import { Box, useBreakpointValue } from '@chakra-ui/react'
import _ from 'lodash'

import FooterOverlay from 'src/components/features/ItListDetails/FooterOverlay/FooterOverlay'
import BrandButton from 'src/components/widgets/buttons/BrandButton'
import { BrandColor } from 'src/types'

import { BuyOptions } from '../../..'

const AffiliateUnlock: React.FC<{
  buy(options?: BuyOptions): unknown
  buyIsLoading: boolean
  brandColor: BrandColor
}> = ({ buy, buyIsLoading, brandColor }) => {
  const isSmMd = useBreakpointValue({ sm: true, lg: false })

  if (isSmMd === undefined) return null

  const UnlockButton = (
    <BrandButton
      brandColor={brandColor}
      borderRadius="full"
      data-testid="itListCard-affiliate-access-button"
      w="full"
      flex={1}
      isLoading={buyIsLoading}
      onClick={() => {
        buy({ eventName: 'Affiliate Access Granted' })
      }}
    >
      Get Affiliate Access
    </BrandButton>
  )

  return isSmMd ? (
    <FooterOverlay>{UnlockButton}</FooterOverlay>
  ) : (
    <Box mb={6}>{UnlockButton}</Box>
  )
}

export default AffiliateUnlock
